import type { ApiActionConfig } from "entities/Action";
import { DEFAULT_ACTION_TIMEOUT, DEFAULT_AGENTIC_ACTION_TIMEOUT} from "ee/constants/ApiConstants";
import {
  HTTP_METHOD,
  EMPTY_KEY_VALUE_PAIRS,
  HTTP_METHODS_DEFAULT_FORMAT_TYPES,
  HTTP_PROTOCOL,
} from "./CommonApiConstants";

const DEFAULT_METHOD_TYPE = HTTP_METHOD.GET;
const DEFAULT_HTTP_VERSION_TYPE = HTTP_PROTOCOL.HTTP11.value;

export const DEFAULT_DATASOURCE_NAME = "DEFAULT_REST_DATASOURCE";

export const DEFAULT_API_ACTION_CONFIG: ApiActionConfig = {
  timeoutInMillisecond: DEFAULT_ACTION_TIMEOUT,
  encodeParamsToggle: true,
  sendFileAsBinary: false,
  httpMethod: DEFAULT_METHOD_TYPE,
  httpVersion: DEFAULT_HTTP_VERSION_TYPE,
  headers: EMPTY_KEY_VALUE_PAIRS.slice(),
  queryParameters: EMPTY_KEY_VALUE_PAIRS.slice(),
  autoGeneratedHeaders: [],
  body: "",
  bodyFormData: [],
  formData: {
    apiContentType: HTTP_METHODS_DEFAULT_FORMAT_TYPES[DEFAULT_METHOD_TYPE],
  },
  pluginSpecifiedTemplates: [
    {
      // JSON smart substitution
      value: true,
    },
  ],
};

export const DEFAULT_AGENTIC_API_ACTION_CONFIG: ApiActionConfig = {
  timeoutInMillisecond: DEFAULT_AGENTIC_ACTION_TIMEOUT,
  encodeParamsToggle: true,
  httpMethod: DEFAULT_METHOD_TYPE,
  httpVersion: DEFAULT_HTTP_VERSION_TYPE,
  headers: EMPTY_KEY_VALUE_PAIRS.slice(),
  queryParameters: EMPTY_KEY_VALUE_PAIRS.slice(),
  autoGeneratedHeaders: [],
  body: "",
  bodyFormData: [],
  formData: {
    apiContentType: HTTP_METHODS_DEFAULT_FORMAT_TYPES[DEFAULT_METHOD_TYPE],
  },
  pluginSpecifiedTemplates: [
    {
      // JSON smart substitution
      value: true,
    },
  ],
};

export const DEFAULT_CREATE_API_CONFIG = {
  config: DEFAULT_API_ACTION_CONFIG,
  datasource: {
    name: DEFAULT_DATASOURCE_NAME,
  },
  eventData: {
    actionType: "API",
  },
};

export const DEFAULT_CREATE_AGENTICAI_API_CONFIG = {
  config: DEFAULT_AGENTIC_API_ACTION_CONFIG,
  datasource: {
    name: DEFAULT_DATASOURCE_NAME,
  },
  eventData: {
    actionType: "API",
  },
};
